import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CountryStatesIndraService = /** @class */ (function () {
    function CountryStatesIndraService(http) {
        this.http = http;
    }
    CountryStatesIndraService.prototype.getCountryConversionCodes = function () {
        var URL = './assets/data/indra_code_conversion.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.prototype.getCountryCodes = function () {
        var URL = './assets/data/indra_country_codes.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.prototype.getUSStates = function () {
        var URL = './assets/data/indra_us_states.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.prototype.getUSAirports = function () {
        var URL = './assets/data/indra_us_airports.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.prototype.getSchengenCountryCodes = function () {
        var URL = './assets/data/indra_schengen_codes.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.prototype.getEUCountryCodes = function () {
        var URL = './assets/data/indra_eu_codes.json';
        return this.http.get(URL);
    };
    CountryStatesIndraService.ngInjectableDef = i0.defineInjectable({ factory: function CountryStatesIndraService_Factory() { return new CountryStatesIndraService(i0.inject(i1.HttpClient)); }, token: CountryStatesIndraService, providedIn: "root" });
    return CountryStatesIndraService;
}());
export { CountryStatesIndraService };
